import Backbone from 'backbone';
import Notice from './notice';

const Notices = Backbone.Collection.extend({
  model: Notice,
});

export default Notices;



/** WEBPACK FOOTER **
 ** ./src/models/notices.js
 **/